<p-toast position="top-right" />
@if (hideShell()) {
  <router-outlet></router-outlet>
} @else {
  <main class="app-shell">
    <io-sidenav
      [visible]="sidenavVisible"
      [status]="sidenavStatus"
      [model]="menuItems()"
      [activeIndex]="activeSidenavIndex()"
      [embedded]="true"
      [dismissible]="false"
      [blockScroll]="false"
      branding="logo"
      [logoSrc]="logoSrc"
      logoText="NTSH"
      [title]="'NTSH'"
      [subtitle]="'common.appTitle' | translate"
      openedWidth="16rem"
      collapsedWidth="4.5rem"
    >
    </io-sidenav>

    <section class="app-shell__main">
      <io-topbar
        [title]="titleKey() | translate"
        [subtitle]="subtitleKey() | translate"
        [icon]="iconKey()"
        styleClass="app-header-topbar"
        [showDivider]="false"
      >
        <div topbar-actions class="header-actions">
          @if (showMenuToggle()) {
            <io-button
              icon="pi pi-bars"
              [rounded]="true"
              [text]="true"
              styleClass="header-icon-btn"
              (click)="onMenuClick()"
              (keydown.enter)="onMenuClick()"
            ></io-button>
          }
          <io-language-switcher></io-language-switcher>
          <div class="header-search">
            <i class="pi pi-search header-search__icon" aria-hidden="true"></i>
            <io-input-text
              [value]="searchValue()"
              [placeholder]="'header.searchPlaceholder' | translate"
              (valueChange)="onSearchChange($event)"
            ></io-input-text>
          </div>

          <app-notification-bell></app-notification-bell>

          <div class="header-user-menu">
            <div class="avatar">{{ userInitials() || '' }}</div>
            <div class="header-user-details">
              <span class="header-user-name">{{ userName() || '' }}</span>
              <span class="header-user-role">{{ userRole() || 'Project Manager' }}</span>
            </div>
            <io-button (click)="onUserMenuToggle($event)" [rounded]="true" [text]="true" icon="pi pi-angle-down">
            </io-button>
          </div>
          <div>
            <io-menu [model]="menuActions()" [popup]="true" [showTrigger]="false" styleClass="account-menu"></io-menu>
          </div>
        </div>
      </io-topbar>

      <section class="app-shell__content">
        <router-outlet></router-outlet>
      </section>
    </section>
  </main>
}
